export const meta = {
  title: '快速上手:从注册到第一张洗车单',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'pos', 'billing'],
};

一杯咖啡还没凉,您的洗车店就能上线营业。本指南带您从注册表单一路走到收下第一张洗车单。

## 1. 注册——30 秒,无需银行卡

打开**注册**页面,填写四项信息:店名、您的姓名、电子邮箱和密码。如果是销售代理介绍您来的,代理编码要么已经附在您的链接里,要么可以手动输入——它绝不会改变您支付的价格。

提交后账号即刻激活:**14 天免费试用**,功能全开,无需绑卡。系统自动登录,直接进入您的管理后台。

## 2. 欢迎向导

首次打开后台,四步向导帮您完成基础设置:

1. **确认门店信息**——店名和地址,按顾客应看到的样子填写。
2. **营业时间**——每周的开门和打烊时间。
3. **上传标志**——上传后我们会为您的顾客端应用生成整套图标。可以先跳过、之后在「品牌」页面补上,但在那之前顾客看到的是占位图。
4. **欢迎卡片**——试用倒计时、您的顾客端应用链接,以及**打开排队看板**按钮。

完成后,您就来到了排队看板——团队每天盯着的那块屏幕。

## 3. 把二维码贴在顾客站的地方

在排队看板顶栏打开**打印二维码**,即可获得可直接打印的门店二维码。贴在入口、收银台——任何车主等候的地方。

顾客扫码后打开的是**您的**网页应用——您的店名、您的配色、您的标志。他们选好洗车套餐、车型,输入车牌号,即可加入排队。无需应用商店,无需下载。

## 4. 第一张洗车单

顾客下单的那一刻,一张带有简短单号和车牌的洗车单就出现在看板的**排队中**一栏。新单排在队尾。

让它在看板上流转:

- 车辆进入洗车位时点**开始**——顾客的单子移到*清洗中*。
- 洗完时点**完成**——顾客会收到「车已洗好」的通知。
- 单子随后停在*待取车*一栏,等待付款。

## 5. 在收银台收款

打开**收银(POS)**页面,所有待取车的单子都列在这里。点开单子,选择顾客的付款方式——现金、DuitNow QR、TNG、GrabPay、银行卡、银行转账、代金券或免单——然后确认。单子归档进历史记录,顾客的会员积分即时到账。

这就是完整闭环:扫码 → 排队 → 清洗 → 完成 → 收款。之后的一切——会员积分、代金券、营销——都建立在这些洗车单之上。

## 下一步

阅读**排队看板**了解调序、挂起和多门店切换;阅读**账单与订阅**了解试用期如何过渡到您的第一张账单。
